var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "input",
    _vm._b(
      {
        staticClass:
          "placeholder-italic form-input flex-1 block rounded-md sm:text-sm sm:leading-5 focus:shadow-none outline-none focus:outline-none focus:border-primary",
        class: [_vm.classes],
        attrs: { id: _vm.id, type: _vm.type, disabled: _vm.disabled },
        domProps: { value: _vm.value },
        on: {
          input: _vm.onInput,
          keypress: _vm.checkSymbol,
          blur: function ($event) {
            return _vm.$emit("blur")
          },
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.$emit("enter")
          },
        },
      },
      "input",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }